/**
 * "Add to Calendar" helpers for events.
 *
 * - `buildGoogleCalendarUrl(event)` → URL to Google Calendar "Add event" page.
 *   Works in every browser without requiring auth or SDKs.
 * - `downloadIcs(eventId, title)` → triggers download of an ICS file served
 *   by the backend. iOS/Android handle .ics natively; desktops pass to the
 *   default calendar app (Apple Calendar, Outlook, Thunderbird, etc.).
 */

// Mirror App.js: same-origin keeps apex/www calls consistent.
const ENV_API = process.env.REACT_APP_BACKEND_URL;
const API = (typeof window !== 'undefined' && window.location && window.location.origin)
  ? window.location.origin
  : ENV_API;

const toGoogleUtc = (isoLike) => {
  if (!isoLike) return '';
  const s = typeof isoLike === 'string' ? isoLike.replace('Z', '+00:00') : isoLike;
  const d = new Date(s);
  if (isNaN(d.getTime())) return '';
  // YYYYMMDDTHHMMSSZ
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getUTCFullYear()}${pad(d.getUTCMonth() + 1)}${pad(d.getUTCDate())}T${pad(d.getUTCHours())}${pad(d.getUTCMinutes())}${pad(d.getUTCSeconds())}Z`;
};

export const buildGoogleCalendarUrl = (event, business = {}) => {
  const start = toGoogleUtc(event.startDate);
  const end = toGoogleUtc(event.endDate || event.startDate);
  const params = new URLSearchParams({
    action: 'TEMPLATE',
    text: event.title || 'Event',
    dates: `${start}/${end}`,
    details: [
      event.description || '',
      business.businessName ? `Hosted by: ${business.businessName}` : '',
      `Details: ${window.location.origin}/business/${event.businessId || ''}`,
    ].filter(Boolean).join('\n'),
    location: event.location || business.address || business.city || '',
  });
  return `https://calendar.google.com/calendar/render?${params.toString()}`;
};

export const downloadIcsUrl = (eventId) => `${API}/api/events/${eventId}/ics`;

export const triggerIcsDownload = (eventId) => {
  // Using a plain anchor ensures browsers see the Content-Disposition header
  // and save the file rather than trying to navigate the SPA to the URL.
  window.location.href = downloadIcsUrl(eventId);
};
